import moment from "moment";

export const Utils = {
  LCL_PICKUP_DELIVERY_POL_POD: {
    1: ["1", "2"],
    2: ["4", "5"],

    3: ["4", "5"],
    4: ["1", "2"],
  },

  CONT_VAN_PICKUP_DELIVERY_HANDLE_TYPE: {
    "1_pickup": ["1", "2"],
    "1_delivery": ["4", "5"],
    "2_pickup": ["4", "5"],
    "2_delivery": ["1", "2"],
    "3_pickup": ["1", "2", "3"],
    "3_delivery": ["1", "2", "3"],
    "4_pickup": ["4", "5"],
    "4_delivery": ["4", "5"],
  },

  BOOKING_NAME: {
    BOOKING_SUBMITTED: 5,
    RECEIVED_BOOKING_REQUEST: 6,
    PLANNED_TRANSPORTATION: 7,
    DELIVERED: 8,
    UNPAID: 9,
    CANCELLED: 10,
    PAID: 11,
    REJECT: 12,
    REFUND: 13,
    RECEIVED_EDIT_REQUEST: 16,
    CONFIRMED_QUOTATION: 17,
    EMPTY_PICKED_UP: 25,
    ARRIVED_AT_THE_WAREHOUSE: 26,
    PICKED_UP_CARGO: 27,
    DELIVERED_CARGO_TO_THE_PORT: 28,
    REACHED_THE_RECEIVING_LOCATION: 29,
    PICKED_UP_CARGO: 30,
    REACHED_THE_DELIVERY_LOCATION: 31,
    DELIVERED_CARGO: 32,
    CARGO_LOADED: 33,
    ARRIVED_DESTINATION_PORT: 34,
    RELEASE_D_O: 35,

    REACHED_THE_RECEIVING_LOCATION: 36,
    REACHED_THE_DELIVERY_LOCATION: 37,
    CARGO_LOADED: 38,
    ARRIVED_DESTINATION_PORT: 39,
    RELEASE_D_O: 40,
    CARGO_LOADED: 41,

    REACHED_THE_RECEIVING_LOCATION: 42,
    REACHED_THE_DELIVERY_LOCATION: 43,
    DELIVERED_CARGO: 44,
    EMPTY_RETURN: 45,
    AWAITING_QUOTE_CONFIRMATION: 61,
    RECEIVED_REVISE_REQUEST: 62,
    RELEASE_BOOKING: 63,
  },
  BOOKING_STATUS: {
    1: "Request a Quotation",
    2: "Quotation Received",
    3: "Quotation Sented",
    4: "Quotation Edited",
    5: "Booking Submitted",
    6: "Received Booking Request",
    7: "Planned Transportation",
    8: "Delivered",
    9: "Unpaid",
    10: "Cancelled",
    11: "Paid",
    12: "Reject",
    13: "Refund",
    16: "Received Edit Request",
    17: "Confirmed Quotation",
    25: "Empty Picked Up",
    26: "Arrived At The Warehouse",
    27: "Picked Up Cargo",
    28: "Delivered Cargo To The Port",
    29: "Reached The Receiving Location",
    30: "Picked Up Cargo",
    31: "Reached The Delivery Location",
    32: "Delivered Cargo",
    33: "Cargo Loaded",
    34: "Arrived Destination Port",
    35: "Release D/O",
    36: "Reached The Receiving Location",
    37: "Picked Up Cargo",
    38: "Reached The Delivery Location",
    39: "Delivered Cargo",
    40: "Cnee Has Received Cargo",
    41: "Picked Up Cargo",
    42: "Arrived At The Warehouse",
    43: "Delivered Cargo",
    44: "Empty Return",
    61: "Awaiting Quote Confirmation",
    62: "Received Revise Request",
    63: "Release Booking",
  },
  BOOKING_NEW: {
    QUOTATION: "3,4,-1",
    APPROVING: "1,2",
    APPROVED: "3,4",
    BOOKING_APPROVAL: "63,62,7",
    CANCELLED: "10,12",
    DELIVERED: "8",
    IN_PROCESS: "61,5,17,16,6",
    IN_TRANSIT: "31,37,38,39,40,41,42,43,44,36,35,34,25,26,27,28,29,30,32,33",
    PAYMENT: "11,9,13",
  },
  BOOKING_TAB: {
    ALL: "61,5,17,16,6,63,62,7,31,37,38,39,40,41,42,43,44,36,35,34,25,26,27,28,29,30,32,33,8,11,9,13,10,12",
    IN_PROCESS: "61,5,17,16,6",
    BOOKING_APPROVAL: "63,62,7",
    CANCELLED: "10,12",
    DELIVERED: "8",
    IN_TRANSIT: "31,37,38,39,40,41,42,43,44,36,35,34,25,26,27,28,29,30,32,33",
    PAYMENT: "11,9,13",
  },
  STATUS_WR1_NEW: {
    QUOTATION: "3,4,-1",
    APPROVING: "1,2",
    APPROVED: "3,4",
    BOOKING_APPROVAL: "63,62,7",
    CANCELLED: "10,12",
    DELIVERED: "8",
    IN_PROCESS: "61,5,17,16,6",
    IN_TRANSIT: "31,37,38,39,40,41,42,43,44,36,35,34,25,26,27,28,29,30,32,33",
    PAYMENT: "11,9,13",
  },
  VIP: "1", // khach hang vip
  CONSTANTS: {
    cleaveNumeral: {
      numeralPositiveOnly: true,
      numeral: true,
      numeralDecimalScale: 3,
      numeralThousandsGroupStyle: "thousand",
      numeralDecimalMark: ".",
      delimiter: ",",
    },
    SALE_EXITS_QUO_BOOK: "2,3,4,5,6,7,8,9,11,21,61,62,63",
    TYPE_UPLOAD: {
      size: 10, // 1Mb
      type: ".jpeg,.jpg,.png,.gif..bmp,.xls,.xlsx,.doc,.docx,.ppt,.pptx,.pdf,.txt,.zip,.rar,.7z",
      max: 20,
      URL: "uploadFile",
    },
    CONFIG_TYPE_NOTIFY: [
      { id: "0", text: "Web" },
      { id: "1", text: "Email" },
      // { id: '2', text: 'Sms' },
    ],
    VOLUMES: [
      { id: 1, text: "1-10" },
      { id: 2, text: "10-30" },
      { id: 3, text: "30-50" },
      { id: 4, text: "50-100" },
      { id: 5, text: ">100" },
    ],
    MOVING_AND_SHIPPING_TYPE_LISTS: [
      { id: 1, text: "Xuất" },
      { id: 2, text: "Nhập" },
      { id: 3, text: "Chuyển kho" },
      { id: 4, text: "Chuyển cảng" },
    ],
    HANDLED_TYPES: [
      { id: 1, text: "Rotatable" },
      { id: 2, text: "Stackable" },
      { id: 3, text: "Non-stackable" },
    ],
    CONFIG_ROLE_TYPE_NOTIFY: [
      { id: "0", text: "WR1" },
      { id: "1", text: "Customer" },
      // { id: '2', text: 'Sms' },
    ],
    STATUS_WR1: {
      QUOTATION: "3,4,21,-1",
      BOOKING: "5,6,61,62,63,7,8,9,10,11,16",
      TRANSPORT: "8",
      REVENUE: "9,11",
      APPROVING: "1,2",
      APPROVED: "3,4,21",
      ACKNOWLED: "61",
      PRICING: "9,11",
      DEPT: "9",
    },
    STATUS_BOOKING: {
      1: "Request a Quotation",
      2: "Quotation Received",
      3: "Đã gửi quotation",
      4: "Đã sửa đổi quotation",
      5: "New Booking",
      6: "In progress",
      7: "New shipment",
      8: "Being transported",
      9: "Completed",
      10: "Canceled",
      11: "Paid",
      21: "KH yêu cầu sửa đổi",
      41: "Request a Quotation",
      61: "Booking Acknowledge",
      62: "Booking Sent",
      63: "Booking Accepted",
      1000: "Xoá",
    },
    USE_TYPE_NOTIFY_A: {
      WEB: { id: "0", text: "WEB" },
      EMAIL: { id: "1", text: "EMAIL" },
      // SMS: { id: '2', text: 'SMS' },
    },

    USER_TYPE_A: [
      //Array list value
      { text: "Admin", value: "0" },
      { text: "Admin_Sale", value: "1" },
      { text: "Client", value: "2" },
      { text: "Client_Root", value: "3" },
    ],

    USER_TYPE_O: {
      //Object value
      Admin: "0",
      Admin_Sale: "1",
      Client: "2",
      Client_Root: "3",
    },
    GENDER_A: [
      { text: "Male", value: "1" },
      { text: "Female", value: "2" },
    ],
    GENDER_O: {
      Male: "1",
      Female: "2",
    },
    LOCATION_TYPE_A: [
      { text: "Choose Location", value: "0" },
      { text: "Create new", value: "1" },
    ],
    LOCATION_TYPE_O: {
      Choose_Location: "0",
      Create_New: "1",
    },
    APPROVE_STATUS_A: [
      { text: "Approving", value: "0" },
      { text: "Approved", value: "1" },
      // { text: 'Reject', value: '2' },
    ],
    APPROVE_STATUS_O: {
      Approving: "0",
      Approved: "1",
      // Reject: '2',
    },
    SERVICE_TYPE: {
      AIR: 1,
      FCL: 2,
      LCL: 3,
      CUSTOM: 4,
      CONTAINER_TRUCKING: 5,
      VAN_TRUCKING: 6,
      // Reject: '2',
    },
    SERVICE_TYPE_ID: {
      1: "AIR",
      2: "FCL",
      3: "LCL",
      4: "CUSTOM",
      5: "CONTAINER_TRUCKING",
      6: "VAN_TRUCKING",
      // Reject: '2',
    },
    SHIPPING_TYPE: {
      NHAP: 1,
      XUAT: 2,
      PORT_TRANSFER: 3,
      D2D: 4,
    },
    constantsTypeName: {
      FCL: 2,
      LCL: 3,
      Customs: 4,
      "Container Trucking": 5,
      "Van Trucking": 6,
      Air: 1,
    },
    constantsTypeId: {
      2: "FCL",
      3: "LCL",
      4: "Customs",
      5: "Container Trucking",
      6: "Van Trucking",
      1: "Air",
    },
  },

  isNullOrEmpty(val) {
    if (
      val === undefined ||
      val === null ||
      val === "" ||
      val.toString().trim() === "" ||
      val.toString().trim() === "undefined" ||
      val.toString().trim() === "null"
    ) {
      return true;
    }
    return false;
  },
  formatMooney(number, type) {
    //'en-US'
    return new Intl.NumberFormat(type, {
      currency: type == "en-US" ? "USD" : "VND",
    }).format(number);
  },
  formatDate(value) {
    if (!value) return "";
    return moment(value).format("DD/MM/YYYY");
  },
  formatCharts(items) {
    var seriesArr = [];
    var categoriesArr = [];
    items = items || [];
    items.map((e) => {
      seriesArr.push(e.value);
      categoriesArr.push(e.colName);
    });

    return { seriesArr, categoriesArr };
  },
  isBlank(value) {
    const isFalsy = (value) => !value;
    const isWhitespaceString = (value) =>
      typeof value === "string" && /^\s*$/.test(value);
    const isEmptyCollection = (value) =>
      (Array.isArray(value) || value === Object(value)) &&
      !Object.keys(value).length;

    if (isFalsy(value)) return true;
    if (isWhitespaceString(value)) return true;
    if (isEmptyCollection(value)) return true;

    return false;
  },
  pieChart(series, labels) {
    return {
      series: series || [44, 55, 41, 17, 14, 4],
      chartOptions: {
        dataLabels: {
          enabled: false,
        },
        labels: labels || [
          "Interlog",
          "1Gate",
          "DHL",
          "Trackify",
          "WR1",
          "Other",
        ],
        colors: [
          "#7367F0",
          "#28C76F",
          "#EA5455",
          "#FF9F43",
          "#1E991E",
          "#EA5485",
        ],

        legend: {
          show: true,
          position: "bottom",
          fontSize: "14px",
        },
        responsive: [
          {
            breakpoint: 992,
            options: {
              chart: {
                height: 380,
              },
              legend: {
                position: "bottom",
              },
            },
          },
          {
            breakpoint: 576,
            options: {
              chart: {
                height: 320,
              },
              plotOptions: {
                pie: {
                  donut: {
                    labels: {
                      show: true,
                      name: {
                        fontSize: "1.5rem",
                      },
                      value: {
                        fontSize: "1rem",
                      },
                      total: {
                        fontSize: "1.5rem",
                      },
                    },
                  },
                },
              },
              legend: {
                show: true,
              },
            },
          },
        ],
      },
    };
  },

  donutChart(series, labels) {
    return {
      series: series || [44, 55, 41, 17, 14, 4],
      chartOptions: {
        dataLabels: {
          enabled: false,
        },
        labels: labels || [
          "Air",
          "FCL",
          "LCL",
          "Custom",
          "Container trucking",
          "Van trucking",
        ],
        colors: [
          "#7367F0",
          "#28C76F",
          "#EA5455",
          "#FF9F43",
          "#1E991E",
          "#EA5485",
        ],

        legend: {
          show: true,
          position: "bottom",
          fontSize: "14px",
        },
        responsive: [
          {
            breakpoint: 992,
            options: {
              chart: {
                height: 380,
              },
              legend: {
                position: "bottom",
              },
            },
          },
          {
            breakpoint: 576,
            options: {
              chart: {
                height: 320,
              },
              plotOptions: {
                pie: {
                  donut: {
                    labels: {
                      show: true,
                      name: {
                        fontSize: "1.5rem",
                      },
                      value: {
                        fontSize: "1rem",
                      },
                      total: {
                        fontSize: "1.5rem",
                      },
                    },
                  },
                },
              },
              legend: {
                show: true,
              },
            },
          },
        ],
      },
    };
  },

  getFirstAndLastDateOfCurrentMonth() {
    var date = new Date();
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    return { firstDay, lastDay };
  },
  formatOption(arr) {
    const mapData = arr.map((obj) => {
      obj.text = obj.text || obj.name;
      obj.id = obj.code;
      return obj;
    });
    return mapData;
  },
  checkIdTrackTrace(request_quotation, shipment_on_tms, shipment_on_fast) {
    var id = 0;
    //FCL + export
    if (
      //LCL + customs + van trucking  xuất
      request_quotation.service_type == Utils.CONSTANTS.SERVICE_TYPE.LCL &&
      request_quotation.has_customs &&
      request_quotation.has_van_trucking &&
      shipment_on_tms?.shipping_type == Utils.CONSTANTS.SHIPPING_TYPE.XUAT
    ) {
      id = 13;
    } else if (
      //FCL + Customs + container trucking  xuất
      request_quotation.service_type == Utils.CONSTANTS.SERVICE_TYPE.FCL &&
      request_quotation.has_customs &&
      request_quotation.has_container_trucking &&
      shipment_on_tms?.shipping_type == Utils.CONSTANTS.SHIPPING_TYPE.XUAT
    ) {
      id = 14;
    } else if (
      //Air + customs + vantrucking  xuất
      request_quotation.service_type == Utils.CONSTANTS.SERVICE_TYPE.AIR &&
      request_quotation.has_customs &&
      request_quotation.has_van_trucking &&
      shipment_on_tms?.shipping_type == Utils.CONSTANTS.SHIPPING_TYPE.XUAT
    ) {
      id = 15;
    } else if (
      //LCL + customs + van trucking  nhập
      request_quotation.service_type == Utils.CONSTANTS.SERVICE_TYPE.LCL &&
      request_quotation.has_customs &&
      request_quotation.has_van_trucking &&
      shipment_on_tms?.shipping_type == Utils.CONSTANTS.SHIPPING_TYPE.NHAP
    ) {
      id = 16;
    } else if (
      //FCL + Customs + container trucking  nhập
      request_quotation.service_type == Utils.CONSTANTS.SERVICE_TYPE.FCL &&
      request_quotation.has_customs &&
      request_quotation.has_container_trucking &&
      shipment_on_tms?.shipping_type == Utils.CONSTANTS.SHIPPING_TYPE.NHAP
    ) {
      id = 17;
    } else if (
      //Air + customs + vantrucking  nhập
      request_quotation.service_type == Utils.CONSTANTS.SERVICE_TYPE.AIR &&
      request_quotation.has_customs &&
      request_quotation.has_van_trucking &&
      shipment_on_tms?.shipping_type == Utils.CONSTANTS.SHIPPING_TYPE.NHAP
    ) {
      id = 18;
    } else if (
      //LCL + van trucking  xuất
      request_quotation.service_type == Utils.CONSTANTS.SERVICE_TYPE.LCL &&
      !request_quotation.has_customs &&
      request_quotation.has_van_trucking &&
      shipment_on_tms?.shipping_type == Utils.CONSTANTS.SHIPPING_TYPE.XUAT
    ) {
      id = 19;
    } else if (
      //FCL + container trucking  xuất
      request_quotation.service_type == Utils.CONSTANTS.SERVICE_TYPE.FCL &&
      !request_quotation.has_customs &&
      request_quotation.has_container_trucking &&
      shipment_on_tms?.shipping_type == Utils.CONSTANTS.SHIPPING_TYPE.XUAT
    ) {
      id = 20;
    } else if (
      //Air + vantrucking  xuất
      request_quotation.service_type == Utils.CONSTANTS.SERVICE_TYPE.AIR &&
      !request_quotation.has_customs &&
      request_quotation.has_van_trucking &&
      shipment_on_tms?.shipping_type == Utils.CONSTANTS.SHIPPING_TYPE.XUAT
    ) {
      id = 21;
    } else if (
      //LCL + van trucking  nhap
      request_quotation.service_type == Utils.CONSTANTS.SERVICE_TYPE.LCL &&
      !request_quotation.has_customs &&
      request_quotation.has_van_trucking &&
      shipment_on_tms?.shipping_type == Utils.CONSTANTS.SHIPPING_TYPE.NHAP
    ) {
      id = 22;
    } else if (
      //FCL + container trucking  nhap
      request_quotation.service_type == Utils.CONSTANTS.SERVICE_TYPE.FCL &&
      !request_quotation.has_customs &&
      request_quotation.has_container_trucking &&
      shipment_on_tms?.shipping_type == Utils.CONSTANTS.SHIPPING_TYPE.NHAP
    ) {
      id = 23;
    } else if (
      //Air + vantrucking  nhap
      request_quotation.service_type == Utils.CONSTANTS.SERVICE_TYPE.AIR &&
      !request_quotation.has_customs &&
      request_quotation.has_van_trucking &&
      shipment_on_tms?.shipping_type == Utils.CONSTANTS.SHIPPING_TYPE.NHAP
    ) {
      id = 24;
    } else if (
      //Container trucking  Xuat
      request_quotation.service_type ==
        Utils.CONSTANTS.SERVICE_TYPE.CONTAINER_TRUCKING &&
      shipment_on_tms?.shipping_type == Utils.CONSTANTS.SHIPPING_TYPE.XUAT &&
      !request_quotation.has_customs
    ) {
      id = 25;
    } else if (
      //Container trucking  nhap
      request_quotation.service_type ==
        Utils.CONSTANTS.SERVICE_TYPE.CONTAINER_TRUCKING &&
      shipment_on_tms?.shipping_type == Utils.CONSTANTS.SHIPPING_TYPE.NHAP &&
      !request_quotation.has_customs
    ) {
      id = 26;
    } else if (
      //Container trucking  chuyển cảng
      request_quotation.service_type ==
        Utils.CONSTANTS.SERVICE_TYPE.CONTAINER_TRUCKING &&
      shipment_on_tms?.shipping_type ==
        Utils.CONSTANTS.SHIPPING_TYPE.PORT_TRANSFER &&
      !request_quotation.has_customs
    ) {
      id = 27;
    } else if (
      //Container trucking  chuyển tải (kho)
      request_quotation.service_type ==
        Utils.CONSTANTS.SERVICE_TYPE.CONTAINER_TRUCKING &&
      shipment_on_tms?.shipping_type == Utils.CONSTANTS.SHIPPING_TYPE.D2D &&
      !request_quotation.has_customs
    ) {
      id = 37;
    } else if (
      //Vantrucking  xuất
      request_quotation.service_type ==
        Utils.CONSTANTS.SERVICE_TYPE.VAN_TRUCKING &&
      shipment_on_tms?.shipping_type == Utils.CONSTANTS.SHIPPING_TYPE.XUAT &&
      !request_quotation.has_customs
    ) {
      id = 28;
    } else if (
      //Vantrucking  nhập
      request_quotation.service_type ==
        Utils.CONSTANTS.SERVICE_TYPE.VAN_TRUCKING &&
      shipment_on_tms?.shipping_type == Utils.CONSTANTS.SHIPPING_TYPE.NHAP &&
      !request_quotation.has_customs
    ) {
      id = 29;
    } else if (
      //Vantrucking  chuyển kho
      request_quotation.service_type ==
        Utils.CONSTANTS.SERVICE_TYPE.VAN_TRUCKING &&
      shipment_on_tms?.shipping_type == Utils.CONSTANTS.SHIPPING_TYPE.D2D &&
      !request_quotation.has_customs
    ) {
      id = 30;
    } else if (
      // LCL  xuất

      request_quotation.service_type == Utils.CONSTANTS.SERVICE_TYPE.LCL &&
      !request_quotation.has_customs &&
      !request_quotation.has_van_trucking &&
      ["6", "8"].includes(shipment_on_fast.detail_service)
    ) {
      id = 1;
    } else if (
      // FCL  xuất

      request_quotation.service_type == Utils.CONSTANTS.SERVICE_TYPE.FCL &&
      !request_quotation.has_customs &&
      !request_quotation.has_van_trucking &&
      shipment_on_fast.detail_service == 4
    ) {
      id = 2;
    } else if (
      //Air xuất
      request_quotation.service_type == Utils.CONSTANTS.SERVICE_TYPE.AIR &&
      !request_quotation.has_customs &&
      !request_quotation.has_van_trucking &&
      shipment_on_fast.detail_service == 2
    ) {
      id = 3;
    } else if (
      //LCL Nhap
      request_quotation.service_type == Utils.CONSTANTS.SERVICE_TYPE.LCL &&
      !request_quotation.has_customs &&
      !request_quotation.has_van_trucking &&
      ["5", "7"].includes(shipment_on_fast.detail_service)
    ) {
      id = 4;
    } else if (
      //FCL Nhap
      request_quotation.service_type == Utils.CONSTANTS.SERVICE_TYPE.FCL &&
      !request_quotation.has_customs &&
      !request_quotation.has_van_trucking &&
      shipment_on_fast.detail_service == 3
    ) {
      id = 5;
    } else if (
      //AIR Nhap
      request_quotation.service_type == Utils.CONSTANTS.SERVICE_TYPE.AIR &&
      !request_quotation.has_customs &&
      !request_quotation.has_van_trucking &&
      shipment_on_fast.detail_service == 1
    ) {
      id = 6;
    } else if (
      //LCL + customs  Xuat
      request_quotation.service_type == Utils.CONSTANTS.SERVICE_TYPE.LCL &&
      request_quotation.has_customs &&
      !request_quotation.has_van_trucking &&
      ["6", "8"].includes(shipment_on_fast.detail_service)
    ) {
      id = 7;
    } else if (
      //FCL + customs  Xuat
      request_quotation.service_type == Utils.CONSTANTS.SERVICE_TYPE.FCL &&
      request_quotation.has_customs &&
      !request_quotation.has_van_trucking &&
      shipment_on_fast.detail_service == 4
    ) {
      id = 8;
    } else if (
      //AIR + customs  Xuat
      request_quotation.service_type == Utils.CONSTANTS.SERVICE_TYPE.AIR &&
      request_quotation.has_customs &&
      !request_quotation.has_van_trucking &&
      shipment_on_fast.detail_service == 2
    ) {
      id = 9;
    } else if (
      //LCL  + customs  nhập
      request_quotation.service_type == Utils.CONSTANTS.SERVICE_TYPE.LCL &&
      request_quotation.has_customs &&
      !request_quotation.has_van_trucking &&
      ["5", "7"].includes(shipment_on_fast.detail_service)
    ) {
      id = 10;
    } else if (
      //FCL  + customs  nhập
      request_quotation.service_type == Utils.CONSTANTS.SERVICE_TYPE.FCL &&
      request_quotation.has_customs &&
      !request_quotation.has_van_trucking &&
      shipment_on_fast.detail_service == 3
    ) {
      id = 11;
    } else if (
      //Air   + customs  nhập
      request_quotation.service_type == Utils.CONSTANTS.SERVICE_TYPE.AIR &&
      request_quotation.has_customs &&
      !request_quotation.has_van_trucking &&
      shipment_on_fast.detail_service == 1
    ) {
      id = 12;
    } else if (
      //Container trucking + Customs Or Customs + Container trucking  Xuat
      (request_quotation.service_type ==
        Utils.CONSTANTS.SERVICE_TYPE.CONTAINER_TRUCKING &&
        shipment_on_tms?.shipping_type == Utils.CONSTANTS.SHIPPING_TYPE.XUAT &&
        request_quotation.has_customs) ||
      (request_quotation.service_type == Utils.CONSTANTS.SERVICE_TYPE.CUSTOM &&
        shipment_on_tms?.shipping_type == Utils.CONSTANTS.SHIPPING_TYPE.XUAT &&
        request_quotation.customs_other_service_type == "CONTAINER")
    ) {
      id = 36;
    } else if (
      //Container trucking + Customs or Customs + Container trucking  nhap
      (request_quotation.service_type ==
        Utils.CONSTANTS.SERVICE_TYPE.CONTAINER_TRUCKING &&
        shipment_on_tms?.shipping_type == Utils.CONSTANTS.SHIPPING_TYPE.NHAP &&
        request_quotation.has_customs) ||
      (request_quotation.service_type == Utils.CONSTANTS.SERVICE_TYPE.CUSTOM &&
        shipment_on_tms?.shipping_type == Utils.CONSTANTS.SHIPPING_TYPE.NHAP &&
        request_quotation.customs_other_service_type == "CONTAINER")
    ) {
      id = 35;
    } else if (
      //Vantrucking + customs  xuất
      (request_quotation.service_type ==
        Utils.CONSTANTS.SERVICE_TYPE.VAN_TRUCKING &&
        shipment_on_tms?.shipping_type == Utils.CONSTANTS.SHIPPING_TYPE.XUAT &&
        request_quotation.has_customs) ||
      (request_quotation.service_type == Utils.CONSTANTS.SERVICE_TYPE.CUSTOM &&
        shipment_on_tms?.shipping_type == Utils.CONSTANTS.SHIPPING_TYPE.XUAT &&
        request_quotation.customs_other_service_type == "VAN")
    ) {
      id = 34;
    } else if (
      //Vantrucking  + customs nhập
      (request_quotation.service_type ==
        Utils.CONSTANTS.SERVICE_TYPE.VAN_TRUCKING &&
        shipment_on_tms?.shipping_type == Utils.CONSTANTS.SHIPPING_TYPE.NHAP &&
        request_quotation.has_customs) ||
      (request_quotation.service_type == Utils.CONSTANTS.SERVICE_TYPE.CUSTOM &&
        shipment_on_tms?.shipping_type == Utils.CONSTANTS.SHIPPING_TYPE.NHAP &&
        request_quotation.customs_other_service_type == "VAN")
    ) {
      id = 33;
    } else if (
      //Customs nhập
      request_quotation.service_type ==
        Utils.CONSTANTS.SERVICE_TYPE.VAN_TRUCKING &&
      shipment_on_tms?.shipping_type == Utils.CONSTANTS.SHIPPING_TYPE.NHAP &&
      request_quotation.has_customs
    ) {
      id = 33;
    } else {
      id = 33;
    }

    return id;
  },
};
